import type { ConfigColor, ConfigColors } from "../../envConfig";

// Always make sure red color is the first in the array (is selected for defaullt color for lines and polygons)
const defaultColors = [
  { border: "white", fill: [255, 0, 0, 1], hex: "#FF0000", name: "red" },
  {
    border: "black",
    fill: [255, 138, 61, 1],
    hex: "#FF8A3D",
    name: "orange",
  },
  {
    border: "black",
    fill: [255, 255, 0, 1],
    hex: "#FFFF00",
    name: "yellow",
  },
  {
    border: "black",
    fill: [0, 255, 0, 1],
    hex: "#00FF00",
    name: "light-green",
  },
  {
    border: "white",
    fill: [0, 135, 90, 1],
    hex: "#00875A",
    name: "dark-green",
  },
  { border: "white", fill: [60, 119, 212, 1], hex: "#3C77D4", name: "blue" },
] as ConfigColor[];

export default {
  colors: defaultColors,
  iconGeneratorColors: defaultColors,
  lineColors: defaultColors,
  polygonFillColors: defaultColors,
  polygonLineColors: defaultColors,
  textBgColors: [
    { fill: [255, 255, 255, 0.01], name: "none" },
    ...defaultColors,
  ],
} as ConfigColors;
